/** @jsxImportSource @emotion/react */
import { memo } from "react";
import { css } from "@emotion/react";

import { calendarButton, nextButton } from "assets/css/shchMtmr";

const small = require("assets/img/link/ico-arrowForward-active.png");
const medium = require("assets/img/link/ico-arrowForward-active@2x.png");
const large = require("assets/img/link/ico-arrowForward-active@3x.png");

/**
 * 【次の1週間】ボタン
 * @param {Number} page 表示ページ
 * @param {function} fn ボタン押下時の挙動
 */
const NextButton = memo(({ page, fn }) => {
  return (
    <button
      type="button"
      css={[page === 0 ? "" : "", calendarButton, nextButton]}
      onClick={fn}
    >
      <img
        css={arrowForwardImg}
        src={small}
        srcSet={`${small} 1x, ${medium} 2x, ${large} 3x`}
        alt="次の1週間"
      />
      <span css={btnTextActive}>次の1週間</span>
    </button>
  );
});

export default NextButton;

const mtgCaption = css`
  font-size: var(--mtg-caption-s);
  font-weight: var(--mtg-caption-w);
`;

const btnTextActive = css`
  ${mtgCaption}
  margin-left: 12px;
  line-height: 40px;
  color: var(--mtg-urbanblue);
`;

const arrowForwardImg = css`
  float: right;
  width: 40px;
  height: 40px;
`;
